import { graphql } from "gatsby"
import React from "react"
import { Col, Container, Row } from "react-bootstrap"
import { PageLayout, PageTitle } from "../components"
import CourseLink from "../components/CourseLink"
import { SEO } from "../utils"

export default ({ data }) => {
  const allPosts = data.allMarkdownRemark.edges || []

  return (
    <PageLayout pageName="formations">
      <SEO title="Formations" />
      <PageTitle title="Formations" />
      <Container className="py-4">
        <div className="course-list">
          {allPosts.map(({ node }) => (
            <CourseLink
              key={node.id}
              url={node.frontmatter.url}
              title={node.frontmatter.title}
              subtitle={node.frontmatter.date}
              image={node.frontmatter.image}
              place={node.frontmatter.place}
              soon={node.frontmatter.soon}
              show={node.frontmatter.show}
              description={node.frontmatter.description}
            />
          ))}
        </div>
      </Container>
    </PageLayout>
  )
}

export const query = graphql`
  query {
    allMarkdownRemark(
      filter: { fileAbsolutePath: { regex: "/formations/" } }
      sort: { fields: [frontmatter___date], order: DESC }
    ) {
      totalCount
      edges {
        node {
          id
          frontmatter {
            title
            description
            image
            place
            date(formatString: "DD MMMM, YYYY")
            soon
            show
            url
          }
          fields {
            slug
          }
        }
      }
    }
  }
`
